import React from "react";

export default function SustainabilityBanner({data}){
  return(
    <>
    <section className="sustainbanner-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-5">
            <h1 className="heading">{data?.leftHead}</h1>
          </div>
          <div className="col-lg-6 col-md-7">
            <span>{data?.rightHead}</span>
            <p>{data?.desc}</p>
          </div>
          </div>
      </div>

      <div className="sustain-bgbanner">
        <img src={data?.img} alt="Sustain Banner Image" />
      </div>
    </section>
    </>
  )
}